import { normalizeAvailableFlights } from "./adapters/flightOfferAdapter";

/**
 * האם להעביר את זרימת ההזמנה לשלב תוצאות אחרי סיום חיפוש טיסות (מהשורה העליונה או אחרת).
 * תואם ללוגיקת תצוגת ResultsStepCard: עסקאות מ-availableFlights או סיום חיפוש RT מקבילי.
 */
export function shouldOpenBookingFlowAfterFlightSearch({
  availableFlights,
  searchGate,
  flightTripType,
  planesFlightSearchOutcome,
}) {
  const deals = normalizeAvailableFlights(availableFlights);
  if (deals.length > 0) return true;
  if (searchGate?.parallelOk) return true;
  if (flightTripType === "OneWay" && planesFlightSearchOutcome === "empty") {
    return true;
  }
  return false;
}
